import { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface ResourceContextType<T, R> {
  response: R | null;
  updateResponse: (data: R) => void;
}

const ResourceContext = createContext<ResourceContextType<any, any> | null>(null);

export const ResourceProvider = <T, R>({ children }: { children: ReactNode }) => {
  const [response, setResponse] = useState<R | null>(null);
  // const [formData, setFormData] = useState<T | null>(null);

  // useEffect(() => {
  //   const savedFormData = localStorage.getItem('formData');
  //   const savedResponse = localStorage.getItem('response');

  //   if (savedFormData) {
  //     setFormData(JSON.parse(savedFormData));
  //   }
  //   if (savedResponse) {
  //     setResponse(JSON.parse(savedResponse));
  //   }
  // }, []);

  const updateResponse = (data: R) => {
    setResponse(data);
    localStorage.setItem('response', JSON.stringify(data));
  }

  return (
    <ResourceContext.Provider value={{ response, updateResponse }}>
      {children}
    </ResourceContext.Provider>
  );
};

export const useResource = <T, R>(): ResourceContextType<T, R> => {
  const context = useContext(ResourceContext);
  if (!context) {
    throw new Error('useResource must be used within a ResourceProvider');
  }
  return context as ResourceContextType<T, R>;
};
